import { Theme } from '../../../types/shared'
import twColors from '../../constants/colors'

export enum ChartAlertIconState {
  default = 'default',
  hover = 'hover',
  active = 'active',
}

export interface IChartAlertIconProps {
  theme: Theme
  state: ChartAlertIconState
  width: number
}

export const ICON_COLORS = {
  [Theme.light]: {
    [ChartAlertIconState.default]: twColors.gray[600],
    [ChartAlertIconState.hover]: twColors.gray[800],
    [ChartAlertIconState.active]: twColors.gray[800],
  },
  [Theme.dark]: {
    [ChartAlertIconState.default]: twColors.gray[200],
    [ChartAlertIconState.hover]: twColors.gray[50],
    [ChartAlertIconState.active]: twColors.gray[50],
  },
}

export enum ChartAlertIconName {
  Plus = 'plus',
  NotificationsOn = 'notificationsOn',
  MoreHorizontal = 'moreHorizontal',
}
